<!-- 3d模型 -->
<template>
  <div id="three">

    

    <div id="chooseFrame" style="position: absolute;left: 10px;top: 10px;background-color: aliceblue;padding:5px;font-weight: bolder;">

    <a-checkbox @change="onChange" :checked="checkFrame">
      {{$t('components.outline')}}
    </a-checkbox>

    <a-button type="primary" size="small" @click="reset" style="display:relative">
      {{$t('components.reset')}}
    </a-button>

    </div>

  </div>
 
</template>


<script>
import * as Three from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import {CSG} from "./three-csg.js"



var container = null

var vector = new Three.Vector2();//三维坐标对象

var rayPoints = null


var raycaster = new Three.Raycaster();

var data_points= null
var data_index = null

var xzModel = null
var loadingFlag = false


export default {
  name: "",
  props: ["datas","height","kuan","chang","lgz","szgd","sz","xz"],
  data() {
    return {
      camera: null,
      scene: null,
      renderer: null,
      mesh: null,
      pointCloudGeometry:null,
      pointCloud:null,
      material:null,
      cPoints:null,
      //粮面高度(锥体上开始计算)
      grainHeight: 410,
      bottomHeight: 80,

      // 窗口尺寸变化
      screenWidth: null,
      timer: null,
      checkFrame:true,
      GLTFobjects:null,
      GLTFobjects0:null,
      myControl:null,



      
    };
  },
  methods: {

    onChange(e) {

      this.checkFrame = e.target.checked

      console.log(`checked = ${e.target.checked}`);

      this.GLTFobjects.visible = this.checkFrame;
      if(this.GLTFobjects0!=null){
        this.GLTFobjects0.visible = this.checkFrame;
      }
      
    },

    reset(){
      this.myControl.reset();
    },

    init() {
      // console.log("??",controls);
      container  =  document.getElementById("three");

      this.scene =  new Three.Scene();
      //this.scene.position(200,200,200)
      var directionalLight = new Three.DirectionalLight(0xffffff, 5);
      directionalLight.name = "directionalLight";
      //directionalLight.position.set(0, 100, 0);
      this.scene.add(directionalLight);

      
      this.camera  =new Three.PerspectiveCamera(
        45, window.innerWidth / window.innerHeight,0.1, 10000);
        this.camera.position.set(0, 0, 50); // 设置相机位置
        this.camera.lookAt(0, 0, 0); 
      this.scene.add(this.camera);
      this.renderer = new Three.WebGLRenderer({
        antialias: false,
        logarithmicDepthBuffer: true,
      });
      var control = new OrbitControls(this.camera, this.renderer.domElement);
      control.update();

      var axes = new Three.AxesHelper(4000);
      axes.position.x = 0;
      axes.position.y = 0;
      axes.position.z = 0;
      //this.scene.add(axes);


      //this.renderer.setClearColor(0x223344);//0x999966
      this.renderer.setClearColor(0x999966);
      this.renderer.setPixelRatio(window.devicePixelRatio);
      this.renderer.outputEncoding = Three.sRGBEncoding;
      this.renderer.physicallyCorrectLights = true;
      this.renderer.setSize(container.clientWidth, container.clientHeight);

      // let geometry = new Three.CylinderBufferGeometry(0.2, 0.2, 0.2);

      // let material = new Three.MeshNormalMaterial();

      // this.mesh = new Three.Mesh(geometry, material);
      // 防止重复渲染
      if (container.children.length > 0) {
        //container.removeChild(container.children[0]);
      }
      container.appendChild(this.renderer.domElement);
      // 加载场景模型
      this.initContent();
      this.myControl = control
    },
    // 加载场景模型
    initContent() {


      // 加载 glTF 格式的模型
     

      this.loadData(this.datas)


  

      
    },



    renderScene() {
      requestAnimationFrame(this.renderScene);
      this.renderer.render(this.scene, this.camera);
    },


    loadData(data){

      let that = this

     
      let loader = new GLTFLoader(); /*实例化加载器*/
      const geometry = new Three.BufferGeometry();

      const positions = [];
      const colors = [];
      let points;
      let indexArr = []
      const color = new Three.Color();

      console.log("datas",this.datas)
      console.log("lgz",this.lgz)
      console.log("height",this.height)
      console.log("kuan",this.kuan)
      console.log("szgd",this.szgd)
      console.log("xz",this.xz)
      console.log("sz",this.z)
      console.log("chang",this.chang)
      

     

        
            for ( let i = 0; i < 10000; i ++ ) {
          
            const x = 2*Math.random() * this.kuan/100;
            const y = this.lgz/1000;
            const  z = 2*Math.random() * this.chang/100;
            positions.push( x, y, z );
            indexArr.push(new Three.Vector3( x, y, z ))
            // colors
            color.setRGB( 255, 204, 0 );
            colors.push( color.r, color.g, color.b );
          }
        

				geometry.setAttribute( 'position', new Three.Float32BufferAttribute( positions, 3 ) );
				geometry.setAttribute( 'color', new Three.Float32BufferAttribute( colors, 3 ) );

				//

       
        
				const material = new Three.PointsMaterial( { size: 3, color:"#FF3300" } );

        material.sizeAttenuation = false;


				points = new Three.Points( geometry, material );
				points.frustumCulled = false;
				this.scene.add( points );


				const axesHelper = new Three.AxesHelper(1000)
				//this.scene.add(axesHelper)
        console.log(indexArr)

        //添加平面
        // triangulate x, z
				var indexDelaunay = Delaunator.from(
						indexArr.map(v => {
							return [v.x, v.z];
						})
				);

				console.log(indexDelaunay)

				var meshIndex = []; // delaunay index => three.js index
				for (let i = 0; i < indexDelaunay.triangles.length; i++){

					meshIndex.push(indexDelaunay.triangles[i]);
				}


				var geom = new Three.BufferGeometry().setFromPoints(indexArr);
				geom.setIndex(meshIndex); // add three.js index to the existing geometry
				geom.computeVertexNormals();
				var mesh0 = new Three.Mesh(
						geom, // re-use the existing geometry
						new Three.MeshBasicMaterial({ color: "#FFCC33", wireframe: true })
				);

				//this.scene.add(mesh0);


				//添加立方体

				//长、框、高、下锥

        let w_height = this.height/100;
        let w_width = this.kuan/100;
        let w_length = this.chang/100;
        let w_shangzhui = this.szgd/100;

        //this.scene.position.set(w_width, w_height*2, w_length)


			

				//添加gltf

        loader.load( '/hxc_model_single/cube_m.glb', function ( gltf ) {

gltf.scene.scale.set(w_width,w_height/2,w_length)

    

that.scene.add( gltf.scene )
that.GLTFobjects = gltf.scene
//render();

} );



if(this.xz == "有"){
  loader.load( '/hxc_model_single/cube_x.glb', function ( gltf ) {

            gltf.scene.traverse( function ( child ) {
              if ( child.isMesh ) {
                child.material = new Three.MeshBasicMaterial({color:"#FF6600"})
              }})

        gltf.scene.scale.set(w_width,w_height*0.05,w_length)
    
       that.scene.add( gltf.scene )

  } );
}

if(this.sz == "有"){
  loader.load( '/hxc_model_single/cube_s.glb', function ( gltf ) {

        gltf.scene.scale.set(w_width,w_shangzhui,w_length)
        gltf.scene.position.set(0, w_height, 0)

        that.scene.add( gltf.scene )
        that.GLTFobjects0 = gltf.scene

  } );
}


          if(!this.isConsole){
          //布尔运算
				var geometry111 = new Three.BoxGeometry( w_width*2, w_height*2, w_length*2 );  // 盒子几何体
				var material111 = new Three.MeshBasicMaterial( { color: 0xFF6600 } );  // 一种材料，设置集合体颜色
				var cube111 = new Three.Mesh( geometry111, material111 );  // 网格，也就是几何体
				cube111.position.set(w_width,w_height,w_length)
        mesh0.updateMatrix()
				cube111.updateMatrix()
				let bspA = new CSG.fromMesh( mesh0 )
				let bspB = new CSG.fromMesh( cube111 )
				let bspResult = bspA.intersect(bspB)
				let meshResult = CSG.toMesh( bspResult, bspB.matrix, bspB.material )
				meshResult.material = material111
        this.scene.add(meshResult)
        meshResult.position.set(-w_width, 0, -w_length)

        }

        points.position.set(-w_width, 0, -w_length)



       
        


      
        

    },

  }, 
  computed: {},
  watch: {
    screenWidth() {
      if (!this.timer) {
        this.timer = true;
        setTimeout(() => {
          this.camera = null;
          this.scene = null;
          this.renderer = null;
          this.mesh = null;
          this.timer = false;
          this.init();
          this.renderScene();
        }, 1000);
      }
    },
    datas:{
      handler:function () {
                      if (typeof this.datas !== "undefined") {
                      this.init();
                      this.renderScene();
                    }
                },
      
    }
  },
  created() {},
  mounted() {

    console.log("chang:",this.chang)
    console.log("kuan:",this.kuan)
    console.log("gao:",this.gao)

    console.log("datas",this.datas)

    if (typeof this.datas !== "undefined") {
      console.log("+++++++++++++++++++++++++++++++")
      this.init();
      this.renderScene();
      
    }
    window.onresize = () => {
      return (() => {
        this.screenWidth = document.body.clientWidth;
      })();
    };
  },
};
</script>

<style lang="scss" scoped>
#three {
  width: 100%;
  height: 100%;
  position: relative;
}
</style>
